/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceSummaryByPoliciesResponse {
    getFixupPrototypeFunction() { return ComplianceSummaryByPoliciesResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceSummaryByPoliciesResponse>): ComplianceSummaryByPoliciesResponse {
        let obj = Object.assign(new ComplianceSummaryByPoliciesResponse(), model);
        ComplianceSummaryByPoliciesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceSummaryByPoliciesResponse>): ComplianceSummaryByPoliciesResponse {
        if (!model) return null;
        return ComplianceSummaryByPoliciesResponse.newInstance(<ComplianceSummaryByPoliciesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceSummaryByPoliciesResponse) {
        if (!obj) return;

        models.ComplianceSummaryByPoliciesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceSummaryByPoliciesResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceSummaryByPoliciesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * total_count
     */
    total_count: string;

    /**
     * page_count
     */
    page_count: string;

    /**
     * policies
     */
    policies: any;

}
